import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'

import ChinaAddressV4Data from '../../common/ChinaAddressV4Data.json'

export default {
name: 'myAddress',
directives: {
TransferDom
},
components: {
XHeader,
Group,
Popup,
Confirm,
XButton,
XSwitch,
XAddress
},
data () {
return {
tblists:[{
name:'公司'
},{
name:'家'
}],
showDelAddress: false,
addressData: [],
haveAddress: true,
selectAddressData: ChinaAddressV4Data,
showNewAddress: false,
isDefaultAddress: false,
addressDialogTitle: '',
NewAddressData: {
token: this.$token,
address: [],
receiver: '',
province: '',
city: '',
district: '',
detail: '',
label:'',
phone: '',
tel: '-',
},
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
delItem: '',
delIndex: '',
}
},
methods: {
listssModel(item){


console.log(item);


this.$set( this.NewAddressData,'label',item.name)

},
getAddressList () {
this.$request.post('/address/list',{
token: this.$token
}).then(data => {
if(data.code == 0){
this.addressData = data.obj
this.haveAddress = true
if(data.obj.length == 0){
this.haveAddress = false
}else{

}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
onShadowChange () {
this.NewAddressData.province = this.$refs.addressArea.nameValue.split(' ')[0]
this.NewAddressData.city = this.$refs.addressArea.nameValue.split(' ')[1]
this.NewAddressData.district = this.$refs.addressArea.nameValue.split(' ')[2]
},
submitNewAddress () { //点击新增地址确定按钮
if(this.$trim(this.NewAddressData.province) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请选择所在地区'
})
return false;
}
if(this.$trim(this.NewAddressData.detail) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入详细地址'
})
return false;
}
if(this.$trim(this.NewAddressData.receiver) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入收货人姓名'
})
return false;
}
if(this.$trim(this.NewAddressData.phone) == ''){
this.$vux.toast.show({
type: 'warn',
text: '请输入手机号码'
})
return false;
}else if(!this.phoneReg.test(this.$trim(this.NewAddressData.phone))){
this.$vux.toast.show({
type: 'warn',
text: '手机号码格式有误'
})
return false;
}

delete this.NewAddressData.address
delete this.NewAddressData.area
delete this.NewAddressData.boolDefault
delete this.NewAddressData.createdTime
delete this.NewAddressData.title
delete this.NewAddressData.updatedTime
delete this.NewAddressData.userId
delete this.NewAddressData.label
if(this.addressDialogTitle == '新增收货地址'){
this.$request.post('/address/add',this.NewAddressData).then(data => {
if(data.code == 0){
this.showNewAddress = false
this.$vux.toast.show({
type: 'success',
text: '新增成功'
})
if(this.isDefaultAddress){
this.setdefault(data.obj.id)
}
setTimeout(() => {
this.getAddressList()
}, 50);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else{
this.$request.post('/address/update',this.NewAddressData).then(data => {
if(data.code == 0){
this.showNewAddress = false
this.$vux.toast.show({
type: 'success',
text: '修改成功'
})
this.addressData.splice(this.delIndex,1,this.NewAddressData)
if(this.isDefaultAddress){
this.setdefault(this.NewAddressData.id)
}
setTimeout(() => {
this.getAddressList()
}, 50);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
console.log(JSON.parse(JSON.stringify(this.NewAddressData)))
},
setdefault (id) {
this.$request.post('/address/setdefault',{
token: this.$token,
id
}).then(data => {
if(data.code == 0){

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
newAddress () {
console.log(JSON.parse(JSON.stringify(this.addressData)))
if(this.addressData.length >= 4){
this.$vux.toast.show({
type: 'warn',
text: '不能添加更多地址'
})
return false;
}else{
this.NewAddressData = {
token: this.$token,
address: [],
receiver: '',
province: '',
city: '',
district: '',
detail: '',
phone: '',
tel: '-',
}
this.isDefaultAddress = false
this.$request.post('/user/getPhone',{
token: this.$token
}).then(data => {
if(data.code == 0){
this.NewAddressData.phone = data.obj
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
this.addressDialogTitle = '新增收货地址'
this.showNewAddress = true
}
},
onConfirm () {  //确定删除
console.log(this.delItem)
this.$request.post('/address/delete',{
token: this.$token,
id: this.delItem.id
}).then(data => {
this.showDelAddress = false
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '已删除'
})
this.addressData.splice(this.delIndex,1)
if(this.addressData.length == 0){
this.haveAddress = false
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
editAddress (item,index) {




this.delItem = {...item,address:[item.province,item.city,item.district],token: this.$token}


this.delIndex = index
this.showNewAddress = true
this.addressDialogTitle = '编辑收货地址'
this.NewAddressData = this.delItem
if(this.NewAddressData.boolDefault == '1'){
this.isDefaultAddress = true
}else{
this.isDefaultAddress = false
}
console.log(item)
},
delAddress (item,index) {
this.delItem = item
this.delIndex = index
this.showDelAddress = true
},
},
created () {
this.getAddressList()
}
}


// WEBPACK FOOTER //
// ./src/views/myAddress/script.js